import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';
import { Table, Whisper, Tooltip } from 'rsuite';

const NotesCell = ({ dataKey, rowData, ...props }) => {
  const note = get(dataKey, rowData);

  if (!note) return <Table.Cell {...props} />;

  return (
    <Table.Cell {...props}>
      <Whisper
        placement="top"
        trigger="hover"
        speaker={<Tooltip>{note}</Tooltip>}
      >
        <span style={{ whiteSpace: 'pre-wrap' }}>{note}</span>
      </Whisper>
    </Table.Cell>
  );
};

NotesCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

NotesCell.defaultProps = {
  rowData: null
};

export default NotesCell;
